import DateRange from "@/js/lookups/date-range";

export default class PlaybookPerformanceReport {
    /**
     */
    constructor(playbook, options) {
        // Assign defaults
        _.merge(this, PlaybookPerformanceReport.defaults());

        if (options) {
            this.status = options.status; // "triggered" ||  completed
            this.outcomeId = options.outcomeId;
            this.userId = options.userId;
            this.metric = options.metric;
            if (options.dateRange) {
                this.dateRange = new DateRange(
                    options.dateRange.typeId,
                    options.dateRange.dates
                );
            }
        }

        if (!this.dateRange) {
            this.dateRange = new DateRange();
        }

        this.playbookId = playbook.id;
        this.playbook = playbook;
    }

    static defaults() {
        return {
            playbook: null,
            status: null,
            outcomeId: null,
            userId: null,
            metric: null,
            dateRange: null,
        };
    }

    valid() {
        return this.status && this.dateRange.typeId;
    }

    definition() {
        if (!this.playbook) return {};
        return {
            playbookId: this.playbook.id,
            status: this.status,
            outcomeId: this.outcomeId,
            dateRange: this.dateRange.definition(),
            userId: this.userId,
            metric: this.metric,
        };
    }

    label() {
        let name = _.get(this.playbook, "name");
        let outcome;
        if (this.outcomeId && this.status == "completed") {
            outcome = this.outcomeId == 1 ? "successfully" : "unsuccessfully";
        }
        let parts = [
            name,
            "instances",
            this.status,
            outcome,
            this.dateRange.dateRangeLabel(),
        ];

        return parts.join(" ");
    }
}
